import { render, staticRenderFns } from "./desc-images-new.vue?vue&type=template&id=9fbf32b0"
import script from "./desc-images-new.vue?vue&type=script&lang=js"
export * from "./desc-images-new.vue?vue&type=script&lang=js"
import style0 from "./desc-images-new.vue?vue&type=style&index=0&id=9fbf32b0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports